import React, { useState } from "react";
import BillingCodesComp from "../notes/component/sharingNotesComponent/BillingCodesComp";
import "../notes/component/feedback/feedback.css"
import "../notes/NewNote.css"
import copy from "../contentReaderMarkdown/copy.svg"
import { formatCode } from "../notes/actions/feedbackActions";
import { ShowAlert } from "../../common/alert";

const SharedCodeViewer = ({ codesOrdersData }) => {
    const [shareObj, setShareObj] = useState({
        selectedCodes: [],
        showShareButton: false,
        openShareModal: null
    })
    const renderItems = (data, val, tabIndex) => {
        return data[val]?.map((s) => {
            return <BillingCodesComp setShareObj={setShareObj} shareObj={shareObj} isCode={tabIndex === 2} items={s} />;
        });
    };

    const codes = codesOrdersData?.codes
    const orders = codesOrdersData?.orders
    const textFormatted = formatCode({ ICD: codes?.ICD, CPT: codes?.CPT, medicationOrders: orders?.medicationOrders, testOrders: orders?.testOrders });

    const copyContent = () => {

        navigator.clipboard
            .writeText(textFormatted.str)
            .then(() => {
                ShowAlert("Copied to clipboard.");
            })
            .catch((error) => {
                ShowAlert("Error copying messages", "error");
            });
    };


    const showICDCodes = (codes?.ICD?.length || null) !== null
    const showCPTCodes = (codes?.CPT?.length || null) !== null
    const showMedication = (orders?.medicationOrders?.length || null)
    const showTest = (orders?.testOrders?.length || null)

    return (
        <div className={`  div-container-main mb-4    `}>
            <div className="div-container-button ">
                <div className="header-text-view-notes"> {textFormatted?.isCode ? " Billing Codes" : "Orders"} </div>
                <button onClick={copyContent} className="button-copy">
                    <img src={copy} alt="copy-icon" className="copy-button-image" />{" "}
                    <div className="copy-action">Copy to Clipboard</div>
                </button>
            </div>
            <div className="height-shared-code-viewer ">
                {showICDCodes && (
                    <>
                        <h1 className="bc-header">{"ICD 10 Codes"}</h1>
                        {renderItems(codes, "ICD", 2)}
                    </>
                )}
                {showCPTCodes && (
                    <>
                        <h1 className="bc-header">{"CPT Codes"}</h1>
                        {renderItems(codes, "CPT", 2)}
                    </>
                )}

                {showMedication && (
                    <>
                        <h1 className="bc-header">{"Medication"}</h1>
                        {renderItems(orders, "medicationOrders", 3)}
                    </>
                )}
                {showTest && (
                    <>
                        <h1 className="bc-header">{"Testing"}</h1>
                        {renderItems(orders, "testOrders", 3)}
                    </>
                )}
            </div>


        </div>
    );
};

export default SharedCodeViewer;
